var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import React from 'react';
import { css, styled } from "../../utils";
import Button, { ButtonProps } from "./Button";
var StyledButton = styled(Button)(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  svg {\n    margin-right: 0.5rem;\n  }\n"], ["\n  display: flex;\n  svg {\n    margin-right: 0.5rem;\n  }\n"]))));
var EditButton = function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    return (React.createElement(StyledButton, __assign({ ghost: true }, props),
        React.createElement(Icon.Edit, null),
        label));
};
EditButton.defaultProps = {
    label: 'ändern',
};
export default EditButton;
var templateObject_1;
//# sourceMappingURL=EditButton.js.map